angular.module('picmonicng').directive('plsAnimateIn', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.addClass(attrs.plsAnimateIn);

        var durations = element.css('animation-duration').split(',');
        var maxDuration = 0;

        for (var a in durations) {
          if (parseFloat(durations[a]) > maxDuration) {
            maxDuration = parseFloat(durations[a]);
          }
        }

        $timeout(function () {
          element.removeClass(attrs.plsAnimateIn);
        }, maxDuration * 1000);
      },
    };
  },
]);
